const iconsWithEvents = new WeakSet();

onDomReady(() => {
   addIconEvents();
});

function addIconEvents(el, force) {
   if (!el) {
      el = document.body;
   }

   let toggleImages = function (icon) {
      let imgs = icon.querySelectorAll('img');
      if (imgs.length == 2) {
         imgs.forEach(img => img.classList.toggle('hidden'));
      }
   };

   el.querySelectorAll('.iconLink').forEach(icon => {
      if (force || !iconsWithEvents.has(icon)) {
         let fn = () => toggleImages(icon);
         iconsWithEvents.add(icon);
         icon.addEventListener('mouseenter', fn);
         icon.addEventListener('mouseleave', fn);
      }
   });

   return el;
}

// eslint-disable-next-line no-var
export var Icons = (window.Icons = {
   addEvents: addIconEvents,
});
